exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".SuccessMsg{padding:60px 0}.SuccessMsg .container{display:flex;justify-content:center;flex-wrap:wrap}.SuccessMsg .container p{font-size:24px;line-height:36px;text-align:center}.SuccessMsg .container .button{margin:60px 0;flex-basis:100%;text-align:center}.SuccessMsg .container .button a{font-size:15px;background:#3ab8e8;padding:10px 20px 11px;color:#fff;font-weight:100;border-radius:4px;cursor:pointer}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-23304f9c","scoped":false,"hasInlineConfig":false}!./node_modules/sass-loader!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/contato/SuccessContact.vue
// module id = 176
// module chunks = 0